// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"329":"admin/css/mm","903":"frontend/css/custom"}[chunkId] + ".css";
};